import styled from 'styled-components';
import { COLORS } from '@/theme';

export const StyledFilterRow = styled.tr`
  &&& {
    th {
      background-color: ${COLORS.LIGHTEST_GRAY};
      padding: 1rem 0.5rem;
    }
    th:last-child {
      border-right: none;
    }
  }
`;
